import { Controller } from "@hotwired/stimulus"

// Clears a <cs-dialog>'s one-time messages (its `message` targets, such as the error callout
// a rejected submit brings back) once the dialog has closed, so reopening it later does not
// show a message from an earlier submit. The server has already spent the flash, so the next
// morph does not bring it back. Wire it on the dialog:
//   data-controller="dialog-messages" data-action="cs-after-hide->dialog-messages#clear"
// cs-after-hide bubbles (composed), and Cornerstone components inside the dialog fire their
// own (a cs-select closing its option list), so only the dialog's own event counts.
export default class extends Controller {
  static targets = ["message"]

  clear(event) {
    if (event.target !== this.element) return
    this.messageTargets.forEach((message) => message.remove())
  }
}
